import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import LogsSidebar from "../LogsSidebar/LogsSidebar";

const LogsLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<LogsSidebar />}>{children}</NavigationBar>
);

export default LogsLayout;
